module.exports = __webpack_public_path__ + "assets/icons/ic_open_with_24px.svg";